export const serverURL = {
  server: {
    url: 'https://parkingds.synology.me:8443',
  },
};
